import { config, apiAuthHeaders } from "../../config/config";

const BASE_URL_UPLOAD = config.API.BASE_URL_UPLOAD;
const BASE_URL_PLAN_SCENARIO = config.API.BASE_URL_PLAN_SCENARIO

export const getListHistoricDrill = async (dataclient, dataproyect) => {
  const client = dataclient;
  const proyect = dataproyect;
  const response = await fetch(
    `${BASE_URL_UPLOAD}/listhistoricdrill/${client}/${proyect}`,
    {
      method: "GET",
      headers: {
        ...apiAuthHeaders(),
      },
    }
  );
  return response.json();
};


export const getListTimeBaseDrill = async (dataclient, dataproyect) => {
  if (!dataclient || !dataproyect) {
    throw new Error("Both dataclient and dataproyect are required");
  }

  const client = dataclient;
  const proyect = dataproyect;

  try {
    const response = await fetch(
      `${BASE_URL_UPLOAD}/listtimebaseddrill/${client}/${proyect}`,
      {
        method: "GET",
        headers: {
          ...apiAuthHeaders(),
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return response.json();
  } catch (error) {
    // console.log("error:", error.message);
    return { error: error.message };
  }
};

// Files go straight to Cloud Storage with a signed URL, then extdata processes them
// from there: Cloud Run rejects request bodies over 32 MiB (413 Content Too Large).
//   1. POST {BASE_URL_UPLOAD}/uploadurl/<kind>/<client>/<project>?filename= -> {url, object, content_type}
//   2. PUT the file to url (direct to storage.googleapis.com)
//   3. POST {BASE_URL_UPLOAD}/<kind>/<client>/<project> with {"object": object}
const uploadThroughStorage = async (kind, client, proyect, formData) => {
  const file = formData?.get ? formData.get("upload") : formData;
  if (!file) {
    return { statusType: "ERROR", statusMessage: "Please select a file to upload." };
  }
  const urlResponse = await fetch(
    `${BASE_URL_UPLOAD}/uploadurl/${kind}/${client}/${proyect}?filename=${encodeURIComponent(file.name)}`,
    { method: "POST", headers: { ...apiAuthHeaders() } }
  );
  const urlData = await urlResponse.json();
  if (urlData?.statusType !== "SUCCESS") {
    return urlData;
  }
  const { url, object, content_type } = urlData.data;
  const put = await fetch(url, {
    method: "PUT",
    headers: { "Content-Type": content_type },
    body: file,
  });
  if (!put.ok) {
    return { statusType: "ERROR", statusMessage: `Upload to storage failed (${put.status}).` };
  }
  const response = await fetch(`${BASE_URL_UPLOAD}/${kind}/${client}/${proyect}`, {
    method: "POST",
    headers: { ...apiAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ object }),
  });
  return response.json();
};

export const uploadHistoricDrill = async (dataHistoric) =>
  uploadThroughStorage("historicdrill", dataHistoric.client, dataHistoric.proyect, dataHistoric.file);

export const uploadTimeBaseDrill = async (timebasedrill) =>
  uploadThroughStorage("timebaseddrill", timebasedrill.client, timebasedrill.proyect, timebasedrill.file);

export const deleteTimeBaseDrill = async (timebasedrill) => {
  const client = timebasedrill.client;
  const proyect = timebasedrill.proyect;
  const response = await fetch(
    `${BASE_URL_UPLOAD}/timebaseddrill/${client}/${proyect}`,
    {
      method: "DELETE",
      headers: {
        ...apiAuthHeaders(),
      },
    }
  );
  return response.json();
};
//APIS EN PROCESO DE IMPLEMENTACION
export const getTBD = async (timebasedrill) => {
  const client = timebasedrill.client;
  const proyect = timebasedrill.proyect;
  const response = await fetch(`${BASE_URL_UPLOAD}/listtimebaseddrill/${client}/${proyect}`, {
    method: "GET",
    headers: {
      ...apiAuthHeaders(),
    },
  });
  return response.json();
};

export const getHistoricDrill = async (timebasedrill) => {
  const client = timebasedrill.client;
  const proyect = timebasedrill.proyect;
  const response = await fetch(`${BASE_URL_UPLOAD}/historicdrill/${client}/${proyect}`, {
    method: "GET",
    headers: {
      ...apiAuthHeaders(),
    },
  });
  return response.json();
};
export const uploadplan = async (plan) => {
  try {
    const client = plan?.filter.clients.toLowerCase();
    const proyect = plan?.filter.proyects.toLowerCase();
    const stream = plan?.filter.platforms.toLowerCase();

    const response = await fetch(
      `${BASE_URL_PLAN_SCENARIO}/plan/${client}/${proyect}/${stream}`,
      {
        method: "POST",
        headers: {
          ...apiAuthHeaders(),
        },
        body: plan.file,
      }
    );
    return response.json();
  } catch (error) {
    throw new Error("Problem getting users");
  }
};
